import { OrderState } from "../dtos/order.dto";

// semantic kitchen-flow states — text + tinted bg + spine colour
export const STATUS_META: Record<string, { label: string; text: string; bg: string; spine: string }> = {
    PENDING:    { label: 'Pending',    text: 'text-state-pending',    bg: 'bg-state-pending/10',    spine: 'bg-state-pending' },
    PREPARING:  { label: 'Preparing',  text: 'text-state-preparing',  bg: 'bg-state-preparing/10',  spine: 'bg-state-preparing' },
    DELIVERING: { label: 'Delivering', text: 'text-state-delivering', bg: 'bg-state-delivering/10', spine: 'bg-state-delivering' },
    DELIVERED:  { label: 'Delivered',  text: 'text-state-delivered',  bg: 'bg-state-delivered/10',  spine: 'bg-state-delivered' },
    CANCELLED:  { label: 'Cancelled',  text: 'text-state-cancelled',  bg: 'bg-state-cancelled/10',  spine: 'bg-state-cancelled' },
};

// fixed kitchen order — used to render the status dropdown consistently
export const ORDER_STATES: OrderState[] = [
    OrderState.PENDING,
    OrderState.PREPARING,
    OrderState.DELIVERING,
    OrderState.DELIVERED,
    OrderState.CANCELLED,
];
